import { Space, Typography } from 'antd';
import React from 'react';

function ErrorComponent() {
  const { Title } = Typography;

  return (
    <Space style={{ padding: '10px', margin: '10px' }}>
      <Title>
        IOTA is down for the rest of the day due to planned maintenance and upgrading.
      </Title>

    </Space>
  );
}

export default ErrorComponent;
